<template>
  <div class="page">
    <div class="login-container">
      <div class="login-header">
        <router-link to="/">
          <img
            class="logo"
            src="@/assets/logo.png"
            id="form-logo"
            alt="Dating4Pets logo"
          />
        </router-link>
        <h1>Date, Care, Alert!</h1>
        <SocialLogin
          class="social-login"
          icon="google"
          @click="loginGoogle"
          text="Continue with Google"
        />
        <SocialLogin
          class="social-login"
          icon="facebook"
          @click="loginFacebook"
          text="Continue with Facebook"
        />
      </div>
      <Form />
    </div>
  </div>
</template>

<script>
import Form from "@/components/Form.vue";
import SocialLogin from "@/components/SocialLogin.vue";
// import VueSession from "vue-session";

export default {
  name: "Login",
  components: { Form, SocialLogin },
  mounted() {
    let self = this;

    if (localStorage.getItem("jwt") !== null) {
      // console.log("User already logged in!");
      self.$router.push("/");
    }
  },
  methods: {
    loginGoogle() {
      location.replace(`${process.env.VUE_APP_BACKEND}/google/auth`);
    },
    loginFacebook() {
      location.replace(`${process.env.VUE_APP_BACKEND}/facebook/auth`);
    },
  },
};
</script>

<style scoped>
/* @import url("https://fonts.googleapis.com/css2?family=Dosis:wght@200;300;400;500;700;800&display=swap");

* {
  font-family: Dosis, sans-serif;
} */

.login-container {
  min-width: 17em;
  /* width: 70%; */
  max-width: 64em;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: row;
  overflow: visible;
  /* opacity: 50%; */
  align-self: center;

  background: red;
  margin: 2em;
  background: white;
  border-radius: 1rem;
  padding-block: 2em;
  padding-inline: 1.5em;
  box-shadow: 0 0.1rem 1rem 0.2rem rgba(126, 126, 126, 0.3);
}
.blob-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: -2;
  overflow: hidden;
}
.graphic-container {
  position: fixed;
  z-index: -1;
}

.login-header h1 {
  font-family: Comfortaa, sans-serif !important;
  /* margin-block-start: 7rem; */
  color: var(--dark-clr);
  /* --alpha: ; */
  /* text-shadow: -0em 0.05em 0.1em rgba(69, 69, 69, 0.69); */
  line-height: 1.5;
}
.login-header {
  margin-inline: auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow: visible;
  gap: var(--gap);
  width: 50%;
  max-width: 17em;
  padding-inline: 1.5em;
  padding-block: 2em;
}

.logo {
  width: 50%;
  aspect-ratio: 1;
}

#image-clipped-0 {
  background: red;
  left: 0 !important;
}

.svg-clipper {
  filter: drop-shadow(0 0 50px black);
}

.image-container {
  width: 50vw;
  position: absolute;
}

/* @media screen and (max-width: 60rem) {
  .login-container {
    width: 100%;
  }
} */

@media screen and (max-width: 40rem) {
  .login-header {
    display: none;
  }

  .login-container {
    /* width: 100%; */
    align-items: center;
    justify-content: center;
  }

  /* .blob-container img {
    transform: scale(3) !important;
  } */
}

@media screen and (max-width: 30rem) {
  .login-container {
    width: 90%;
  }

  /* .blob-container img {
    transform: scale(3) !important;
  } */

  /* .login-header {
    display: none;
  } */
}

/* .social-login {
  min-width: 15em;
  width: 80%;
  max-width: 20em;
} */

.page {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* .cont-3,
.cont-5 {
  display: none !important;
} */
</style>
